const btnsOpenVideo = document.querySelectorAll(
  ".nuestros-clientes-carousel modal-opener .product-popup-modal__button"
);
btnsOpenVideo.forEach((btn) => {
  btn.addEventListener("click", (e) => {
    let typevideo = btn.dataset.typevideo;
    let dataid = btn.dataset.mediaId;
    let modalid = btn.dataset.modalid;
    if (typevideo == "youtube") {
      let url = `https://www.youtube.com/embed/${dataid}?enablejsapi=1`;
      let iFrameObj = document.createElement("iframe");
      iFrameObj.classList.add("js-youtube");
      iFrameObj.src = url;
      let modalOpenVideo = document.querySelector(`#${modalid} deferred-media`);
      let modalOpenVideoIfram = document.querySelector(
        `#${modalid} deferred-media iframe`
      );
      if (Boolean(modalOpenVideoIfram)) {
        //
      } else {
        modalOpenVideo.appendChild(iFrameObj);
        iFrameObj.addEventListener("load", (l) => {
          modalOpenVideo.setAttribute("loaded", true);
        });
      }
    }
    console.log(btn);
  });
});

document.querySelectorAll(".product-popup-modal__opener").forEach((opener) => {
  opener.addEventListener("click", function () {
    const modalSelector = this.getAttribute("data-modal"); // Obtiene el valor de data-modal, que incluye #
    const modalId = modalSelector.replace("#", ""); // Elimina el #
    const modal = document.getElementById(modalId); // Selecciona el modal usando solo el ID

    if (modal) {
      modal.setAttribute("open", ""); // Agrega el atributo "open" al modal
    }
  });
});
